import { PostAskRequestEmail } from 'domain/usecases/ask-customer/post-create-ask-request-email';
import { BaseHttpService } from 'main/factories/http';

export class RemotePostAskRequestEmail
  extends BaseHttpService<PostAskRequestEmail.Model>
  implements PostAskRequestEmail
{
  async post(body: PostAskRequestEmail.Body): Promise<PostAskRequestEmail.Model> {
    return await this.request('post', body);
  }
}
